<!--
	LandingPage2.svelte

    new 11/11/22

    This is the latest Figma mockup and contains large Header and Footer

-->

<script>
	import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    import { signIn, signOut } from '../../common/auth.js';
    import { masterSearch } from '../../common/master-objects.js';
    import { runPublicPostalSearch } from '../../common/public-search-utils.js';
    import { validatePostalCode } from "../../common/utils.js";
    import { setWarningAlert, setErrorAlert } from '../../stores/AlertsStore';
    import { AccountStore } from "../../common/account";
    import {isShowingResourceList,isShowingZipError} from '../../stores/ScreenSettingsStore';

    // Vito code for Lindsey demos?
    import { DEMO_POSTAL_WARNING_MSG, isPostalLockedWithWrongPostal } from "../../../demo.js";

    // TCARE components
    import LandingPageHeader from './LandingPageHeader.svelte';
    import LandingPageContent from './LandingPageContent.svelte';
    import LandingPageFooter from './LandingPageFooter.svelte';
    import PageAlert from '../common/PageAlert.svelte';

    const POSTAL_WARNING_MSG = 'Please enter a valid ZIP Code.';
    const SEARCH_ERROR_MSG = 'An error occurred during your search.';

    $: isRunningSearch = false;

    onMount(() => {
        if (!$AccountStore?.isLoggedIn) {
            // console.log('LandingPage2 - not logged in');
        }

        // clear out all search params INCLUDING ZIP Code
        $masterSearch.location.postalCode = '';
        $masterSearch.text = '';
        $masterSearch.clearTaxonomies();
        $masterSearch = $masterSearch;
    })

    // button route handlers for Header
    const onHomeClick = () => {
        push('/home');
    }

    const onLoginClick = () => {
        if ($AccountStore.isLoggedIn) {
            signOut();
        } else {
            signIn();
        }
    }

    // button route handlers for Footer
    const onAboutClick = () => {
        window.open('http://www.tcare.ai/about', "_blank")
    }

    const onTermsClick = () => {
        push('/terms');
    }

    const onPrivacyClick = () => {
        // push('/privacy');
        window.open('http://www.tcare.ai/content/privacy', "_blank")
    }


    const onSearch = async () => {
        if (!validatePostalCode($masterSearch.location.postalCode)) {
            $isShowingZipError = true
            return;
        }
        // Vito check for demo - always use 70125
        if (isPostalLockedWithWrongPostal($masterSearch.location.postalCode)) {
            setWarningAlert(DEMO_POSTAL_WARNING_MSG, 3000);
            return;
        }

        // clear out all search params except ZIP Code
        $masterSearch.text = '';
        $masterSearch.clearTaxonomies();
        $masterSearch = $masterSearch;
        $isShowingResourceList = false;
        $isShowingZipError = false;


        isRunningSearch = true;
        let results = await runPublicPostalSearch(masterSearch);             // in public-search-utils.js
        isRunningSearch = false;


        if (results.errors) {
            $isShowingZipError = true
        } else {
            $isShowingZipError = false
            push('/postal-results');
        }
    }
    
</script>

<style>

    .landing-page-2 {
        height: 90vh;
        background-color: var(--tcui-dark-purple);
    }

</style>

<div class="landing-page-2">
    <LandingPageHeader {onHomeClick} {onLoginClick}/>
    <LandingPageContent {onLoginClick} {onSearch} {isRunningSearch} {isShowingZipError} />
    <LandingPageFooter {onAboutClick} {onTermsClick} {onPrivacyClick} />
    <PageAlert />
</div>

